"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("@powerednow/complexData/entity");
let WhiteLabelEntity = class WhiteLabelEntity extends entity_1.EntityWithId {
};
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true })
], WhiteLabelEntity.prototype, "id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], WhiteLabelEntity.prototype, "name", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], WhiteLabelEntity.prototype, "account_number_validation_rule", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], WhiteLabelEntity.prototype, "report_email", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], WhiteLabelEntity.prototype, "include_po_reporting", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], WhiteLabelEntity.prototype, "include_po_reporting_on_partner", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], WhiteLabelEntity.prototype, "desktop_url", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', allowNull: true, defaultValue: null })
], WhiteLabelEntity.prototype, "fallback_whitelabel_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', defaultValue: 1, hooks: { afterUpdate: [{ handler: 'updateTestCompanies', condition: { newValue: 2 }, args: [] }] } })
], WhiteLabelEntity.prototype, "whitelabel_status", void 0);
WhiteLabelEntity = __decorate([
    entity_1.EntityDecorator
], WhiteLabelEntity);
exports.default = WhiteLabelEntity;
//# sourceMappingURL=../../../../src/models/whiteLabel/entity.js.map